import { logError } from '@zg-rentals/log-error';
import { unsubscribeAll } from 'app/shared/flux/actions/MarketingActions';

const serverRouteWillMount = ({ store }: { store: any }) => {
  const { dispatch } = store;
  const state = store.getState();
  const query = state.router.location.query;

  const { email, cancelHash } = query;
  return dispatch(unsubscribeAll({ email: decodeURIComponent(email), cancelHash })).catch(
    (error: { message: string; code: string }) => {
      logError({
        error,
        errorType: 'Subscription',
        context: {
          details: 'Unsubscribe All Page: Error unsubscribing user.',
          root: 'pages/UnsubscribeAllPage#serverRouteWillMount',
        },
      });
    },
  );
};

export default serverRouteWillMount;
